import React, { Component } from 'react'
//import '../../css//App.css';

class Pigments extends Component {

  render() {
    return (
        <div>
            <div className="mt-5 grid grid-cols-1 md:grid-cols-2">
                <div>
                    <h3 className="font-bold">Pointer Selector</h3>
                </div>
                <div>
                    <h3 className="font-bold">Saved Pigment</h3>
                </div>
            </div>

            <div className="mt-1 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow md:grid-cols-2">
                <div className="flex overflow-hidden shadow rounded-l-lg px-4 py-5 sm:p-6" style={{backgroundColor: this.props.hex}}>
                    <div className="flex-1 text-center">
                        { (this.props.hsv.s - this.props.hsvSaved.s < 0) ? (
                            <svg className={ (this.props.hsv.v < 50) ? "text-white mx-auto flex-shrink-0 self-center h-5 w-5" : "text-black mx-auto flex-shrink-0 self-center h-5 w-5"} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                            </svg>
                        ) : (
                            <svg className={ (this.props.hsv.v < 50) ? "text-white mx-auto flex-shrink-0 self-center h-5 w-5" : "text-black mx-auto flex-shrink-0 self-center h-5 w-5"} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd"/>
                            </svg>
                        )}
                        <span className={ (this.props.hsv.v < 50) ? "font-bold text-white" : "font-bold text-black"}>Chroma</span>
                    </div>
                    <div className="flex-1 text-center">
                        { (this.props.hsv.v - this.props.hsvSaved.v < 0) ? (
                            <svg className={ (this.props.hsv.v < 50) ? "text-white mx-auto flex-shrink-0 self-center h-5 w-5" : "text-black mx-auto flex-shrink-0 self-center h-5 w-5"} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                            </svg>
                        ) : (
                            <svg className={ (this.props.hsv.v < 50) ? "text-white mx-auto flex-shrink-0 self-center h-5 w-5" : "text-black mx-auto flex-shrink-0 self-center h-5 w-5"} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd"/>
                            </svg>
                        )}
                        <span className={ (this.props.hsv.v < 50) ? "font-bold text-white" : "font-bold text-black"}>Value</span>
                    </div>
                </div>
                <div className="cursor-palette overflow-hidden shadow rounded-r-lg" style={{backgroundColor: this.props.hexSaved}} onClick={() => this.props.addToPalette(this.props.hexSaved)}>
                    <div className={ (this.props.hsvSaved.v < 50) ? "font-bold text-white text-center mt-8 hover:underline" : "font-bold text-black text-center mt-8 hover:underline"}>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Pigments;
